// @styles
require('./amazonGiftCard.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const { OKCover } = require('commonsComponents/OKCover');
// @components
const OKRadioGroup = require('components/commons/OKRadioGroup/OKRadioGroup');
const OKRadioSwitch = require('components/commons/OKRadioSwitch/OKRadioSwitch');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const AmazonGiftCardPromotions = require('components/amazonGiftCardPromotions/amazonGiftCardPromotions');
const AmazonGiftCardCoupons = require('components/amazonGiftCardCoupons/amazonGiftCardCoupons');
const AmazonGiftCardConsentModal = require('components/amazonGiftCardPromotions/amazonGiftCardConsentModal/amazonGiftCardConsentModal');
const AmazonGiftCardConsentErrorModal = require('components/amazonGiftCardPromotions/amazonGiftCardConsentErrorModal/amazonGiftCardConsentErrorModal');

// @actions
const amazonGiftCardActions = require('actions/amazonGiftCard');
const retailLoanActions = require("ok-loans/src/actions/contractRetailLoan");
// @constants
const {
    SELECTED_RADIO_PROMOTIONS,
    SELECTED_RADIO_COUPON,
    AMAZON_GIFT_CARD_LOCATION_ID,
    AMAZON_CONSENTS_STATUS,
    CODIGOS_TEXT,
    PROMOCIONES_TEXT
} = require('constants/accountAmazonGiftCard');
const {
    RETAIL_LOAN_CONSENTS_ID
} = require("ok-loans/src/loansConstants/index");
const {
    AMAZON_PROMOCIONES
} = require('constants/tagging');
// @assets
const openMarketsIcon = require('assets/images/icon-openmarkets-filled.svg');
//@utils
const {
    recordLinkV2
} = require("utilities/tagging");

class AmazonGiftCardView extends React.Component {
    constructor(props) {
        super(props);
        this.handleRadioGroupChangeCC = this.handleRadioGroupChangeCC.bind(this);
        this.handleRadioGroupChange = this.handleRadioGroupChange.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.navigateToAccountMovements = this.navigateToAccountMovements.bind(this);
        this.updateConsentStatus = this.updateConsentStatus.bind(this);
        const activeTab = new URLSearchParams(props.location.search).get('activeTab');

        this.state = {
            selectedRadio: activeTab || SELECTED_RADIO_PROMOTIONS
        }
    }

    componentDidMount() {
        const {
            getAmazonCouponCodeInfo,
            getAmazonPromotionCard,
            getConsentStatus
        } = this.props;
        getAmazonPromotionCard(AMAZON_GIFT_CARD_LOCATION_ID);
        getAmazonCouponCodeInfo();
        !__CONTACT_CENTER__ && getConsentStatus();
    }

    componentWillUnmount() {
        const { clearFilters, reset, resetErrorStatus } = this.props;
        clearFilters();
        reset();
        !__CONTACT_CENTER__ && resetErrorStatus();
    }

    handleRadioGroupChangeCC(value) {
        const { setAmazonConsultType } = this.props;

        setAmazonConsultType(value);

        switch (value) {
            case SELECTED_RADIO_COUPON:
                this.props.getAmazonCouponCodeInfo();
                break;
            case SELECTED_RADIO_PROMOTIONS:
                this.props.getAmazonPromotionCard(AMAZON_GIFT_CARD_LOCATION_ID);
                break;
        }
    }

    handleRadioGroupChange(value) {
        this.setState({
            selectedRadio: value
        })

        __CONTACT_CENTER__ && this.handleRadioGroupChangeCC(value);

        const customData = ({
            categoriaEvento: AMAZON_PROMOCIONES,
            accionEvento: "promocionesCodigosTabs",
            etiquetaEvento: value === SELECTED_RADIO_COUPON ? CODIGOS_TEXT : PROMOCIONES_TEXT
        });
        recordLinkV2(customData);
    }

    handleRowClick(amount, requestId, id) {
        this.props.setAmazonPromoCode(amount, requestId, id);
    }

    buildRadioSwitch() {
        return (
            <div className="amazon-gift-card-view__radio-switch" >
                <OKRadioGroup
                    name="amazonGiftPromoCoupons"
                    onChange={value => this.handleRadioGroupChange(value)}
                    selectedValue={this.state.selectedRadio}
                >
                    <OKRadioSwitch
                        className="amazon-gift-card-view__radio-switch-item"
                        value={SELECTED_RADIO_PROMOTIONS}
                    >
                        <FormattedText value="amazonGiftCard-promotion" />
                    </OKRadioSwitch>
                    <OKRadioSwitch
                        className="amazon-gift-card-view__radio-switch-item"
                        value={SELECTED_RADIO_COUPON}
                    >
                        <FormattedText value="amazonGiftCard-couponCode" />
                    </OKRadioSwitch>
                </OKRadioGroup>
            </div>
        );
    }

    buildContent() {
        const {
            getAmazonCouponCodeInfo,
            getAmazonPromotionCard,
            immAccounts,
            immAmazonGiftCard,
            match: { params: { accountId } },
            resetFilter,
            requestNextAmazonCouponCodeInfoPage,
            setFilters,
            clearFilters
        } = this.props;
        const selectedAccount = immAccounts.getIn(['byId', accountId]);
        let content;

        switch (this.state.selectedRadio) {
            case SELECTED_RADIO_PROMOTIONS:
                content = (
                    <AmazonGiftCardPromotions
                        immAccounts={immAccounts}
                        immAmazonGiftCard={immAmazonGiftCard}
                        getAmazonPromotionCard={getAmazonPromotionCard}
                        selectedAccount={selectedAccount}
                    />
                );
                break;
            case SELECTED_RADIO_COUPON:
                content = (
                    <AmazonGiftCardCoupons
                        accountId={accountId}
                        immAmazonGiftCard={immAmazonGiftCard}
                        getAmazonCouponCodeInfo={getAmazonCouponCodeInfo}
                        onRowClick={this.handleRowClick}
                        resetFilter={resetFilter}
                        setFilters={setFilters}
                        clearFilters={clearFilters}
                        requestNextAmazonCouponCodeInfoPage={requestNextAmazonCouponCodeInfoPage}
                    />
                );
                break;
        }

        return content;
    }

    renderheaderGiftCard() {
        const { immGlobalVariables } = this.props;
        const promotionalPercentage = immGlobalVariables.getIn(['variables', 'parameters', 'amazon_gift_cards_promotional_percentage', 'value']) || '';
        const promotionHeader = <FormattedText value="amazonGiftCard-promotionHeader" injectedStrings={[promotionalPercentage]} />

        const title = (this.state.selectedRadio === SELECTED_RADIO_PROMOTIONS) ?
            promotionHeader : formatText('amazonGiftCard-couponCodeHeader');
        return (
            <p className="amazon-gift-card-view__header-title">
                {title}
            </p>
        );
    }

    navigateToAccountMovements() {
        this.props.history.goBack();
    }

    updateConsentStatus() {
        const { updateUserConsent } = this.props;
        const consents = [
            {
                consentCellId: RETAIL_LOAN_CONSENTS_ID.AMAZON_CONSENT_ID,
                status: AMAZON_CONSENTS_STATUS.ACCEPTED
            }
        ];
        updateUserConsent(consents);
    }

    render() {
        let consentModalContent;
        let consentModalErrorContent;
        if (!__CONTACT_CENTER__) {
            const { immRetailLoan } = this.props;
            const consentStatus = immRetailLoan.get('acceptAmazonConsentsStatus');
            const isUpdatingUserConsent = immRetailLoan.get("isUpdatingUserConsent");
            const hasErrorGettingConsentsStatus = immRetailLoan.get('hasErrorConsentsStatus');
            const hasErrorUpdatingUserConsent = immRetailLoan.get('hasErrorUpdatingUser');
            let showConsentModal = false;
            let showConsentErrorModal = false;
            let consentModalErrorDescription = '';

            if (hasErrorGettingConsentsStatus) {
                showConsentErrorModal = true;
                consentModalErrorDescription = formatText('amazonConsentModal-errorModalDescription');
            } else if (hasErrorUpdatingUserConsent) {
                showConsentErrorModal = true;
                consentModalErrorDescription = formatText('amazonConsentModal-errorModalSubmitDescription');
            } else {
                showConsentModal = consentStatus ? consentStatus !== AMAZON_CONSENTS_STATUS.ACCEPTED : false;
            }
            consentModalContent = (
                <AmazonGiftCardConsentModal
                    showModal={showConsentModal}
                    handleSubmit={this.updateConsentStatus}
                    onCancelClick={this.navigateToAccountMovements}
                    isUpdatingUserConsent={isUpdatingUserConsent}
                />
            );
            consentModalErrorContent = (
                <AmazonGiftCardConsentErrorModal
                    showModal={showConsentErrorModal}
                    title={formatText('amazonConsentModal-errorModalTitle')}
                    description={consentModalErrorDescription}
                    handleSubmit={this.navigateToAccountMovements}
                />
            );
        }

        const { match: { params: { accountId } }, immAccounts } = this.props;
        const immAccount = immAccounts.getIn(['byId', accountId]);
        const radioSwitchContent = this.buildRadioSwitch();
        const content = this.buildContent();
        const headerGiftCard = this.renderheaderGiftCard();
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: immAccount.get('alias'),
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('breadcrumb-amazonGiftCard'),
                url: ''
            }
        ];

        const bodyBlock = (
            <div className="col-xs-12">
                <section className="amazon-gift-card-view__section">
                    {headerGiftCard}
                    {radioSwitchContent}
                    {content}
                </section>
            </div>
        );

        return (
            <div className="amazon-gift-card-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover
                            size="medium"
                            section="accounts"
                            customClass="col-xs-12"
                        >
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={formatText('amazonGiftCard-pageTitle')}>
                                <img src={openMarketsIcon} className="openmarkets-icon" />
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {bodyBlock}
                        </div>
                    </div>
                </div>
                {consentModalContent}
                {consentModalErrorContent}
            </div>
        );
    }
}

AmazonGiftCardView.propTypes = {
    getAmazonCouponCodeInfo: PropTypes.func.isRequired,
    getAmazonPromotionCard: PropTypes.func.isRequired,
    getConsentStatus: PropTypes.func.isRequired,
    updateUserConsent: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAmazonGiftCard: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object,
    immRetailLoan: PropTypes.object.isRequired,
    location: PropTypes.object,
    match: PropTypes.object.isRequired,
    requestNextAmazonCouponCodeInfoPage: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    setAmazonConsultType: PropTypes.func.isRequired,
    setAmazonPromoCode: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
    resetErrorStatus: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
};

module.exports.constructor = AmazonGiftCardView;
module.exports.AmazonGiftCardView = connect(
    state => ({
        immAccounts: state.accounts,
        immAmazonGiftCard: state.amazonGiftCards,
        immGlobalVariables: state.globalVariables,
        immRetailLoan: state.contractRetailLoan,
    }),
    {
        clearFilters: amazonGiftCardActions.clearAmazonGiftCardsFilter,
        getAmazonCouponCodeInfo: amazonGiftCardActions.getAmazonCouponCodeInfo,
        getAmazonPromotionCard: amazonGiftCardActions.getAmazonPromotionCard,
        getConsentStatus: retailLoanActions.getConsentStatus,
        requestNextAmazonCouponCodeInfoPage: amazonGiftCardActions.requestNextAmazonCouponCodeInfoPage,
        reset: amazonGiftCardActions.reset,
        resetFilter: amazonGiftCardActions.resetAmazonGiftCardsFilter,
        setAmazonConsultType: amazonGiftCardActions.setAmazonConsultType,
        setAmazonPromoCode: amazonGiftCardActions.setAmazonPromoCode,
        setFilters: amazonGiftCardActions.setAmazonGiftCardsFilter,
        updateUserConsent: retailLoanActions.updateUserConsent,
        resetErrorStatus: retailLoanActions.simpleActions.retailLoanResetErrorsStatus,
    }
)(withRouter(AmazonGiftCardView));
